export const PORTAL_URL = process.env.PORTAL_URL;
export const BACKEND_URL = process.env.BACKEND_URL;
export const PROXY_URL = process.env.PROXY_URL;
export const PUBLIC_URL = process.env.PUBLIC_URL;


